import * as React from 'react'
import * as PropTypes from 'prop-types'
import { injectIntl, WrappedComponentProps } from 'react-intl'

import { TextField, ITextFieldProps } from '../text-field'
import { IInputProps } from '../../types'
import { normalizeNumberInput, formatNumber, parseNumber } from '../../utils/numbers'

const formatOptions = {
  multiplier: 100,
}
const parseOptions = {
  multiplier: 100,
  maximumFractionDigits: 2,
}
const normalizeOptions = {
  maximumFractionDigits: 2,
}

function isFormEvent(value: unknown): value is React.FormEvent<HTMLInputElement> {
  return !!(value && (value as React.FormEvent).currentTarget)
}

interface IAmountFieldProps {
  value?: number
  onChange: (value: number | null) => void
}

interface IAmountFieldState {
  value: string
}

type TAmountFieldProps = ITextFieldProps &
  IAmountFieldProps & { input?: IInputProps<number | null, number> } & IInputProps<number | null, number> &
  WrappedComponentProps

export const AmountField = injectIntl(
  class AmountField extends React.Component<TAmountFieldProps, IAmountFieldState> {
    static propTypes = {
      value: PropTypes.number,
      onChange: PropTypes.func.isRequired,
    }

    constructor(props: TAmountFieldProps) {
      super(props)

      this.state = { value: formatNumber(props.intl, props.value, formatOptions) }
    }

    static getDerivedStateFromProps(props: TAmountFieldProps, state: IAmountFieldState) {
      const { value } = props

      if (value !== parseNumber(state.value, parseOptions)) {
        return { value: formatNumber(props.intl, value, formatOptions) }
      }

      return null
    }

    handleChange = (e?: string | boolean | React.FormEvent<HTMLInputElement> | undefined) => {
      if (!isFormEvent(e)) {
        return null
      }

      const { onChange: propOnChange } = this.props

      const value = normalizeNumberInput(e.currentTarget.value, normalizeOptions)

      propOnChange(parseNumber(value, parseOptions))

      this.setState({
        value,
      })
    }

    render() {
      const { value, onChange, input, ...props } = this.props

      return (
        <TextField
          {...props}
          input={
            input && {
              ...input,
              value: this.state.value,
              onChange: this.handleChange,
            }
          }
          onChange={this.handleChange}
          type="tel"
          value={this.state.value}
        />
      )
    }
  }
)
